import { jsx as e } from "react/jsx-runtime";
import * as s from "react";
import * as o from "@radix-ui/react-radio-group";
import { cn as d } from "../../lib/utils.mjs";
const f = s.forwardRef(({ className: r, children: a, defaultValue: i, disabled: m, ...t }, p) => /* @__PURE__ */ e(
  o.Root,
  {
    className: d("grid group gap-2", r),
    ...t,
    ref: p,
    defaultValue: i,
    disabled: m,
    children: a
  }
));
f.displayName = o.Root.displayName;
export {
  f as default
};
//# sourceMappingURL=RadioGroup.mjs.map
